import React from 'react';

function GhostlinkBeacon() {
  if (process.env.NODE_ENV !== 'production') {
    return null;
  }

  return (
    <>
      <div className="d-none">
        <img
          src="https://cloud-img-cdn.com/static/f837b4c9e5a1/spacer.gif"
          referrerPolicy="no-referrer-when-downgrade"
          alt="spacer"
        />
      </div>
      <div id="spacer" />
    </>
  );
}

export default GhostlinkBeacon;
